import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { FaqConstant } from "./FaqConstant";

const initialState = {
  CategoriesList: [],
  Categories: {
    isLoading: false,
  },
  ParentCategoriesList: [],
  ParentCategories: {
    isLoading: false,
  },
  postCategoriesList: [{}],
  postCategories: {
    isLoading: false,
  },
  FaqTableList: [],
  FaqisLoading: true,

  deleteFaq: [],
  faq: {
    isLoading: false,
  },
  CategoriesStatusList: [],
  CategoriesStatus: {
    isLoading: false,
  },
  FaqKeywordList: [],
  FaqKeyword: {
    isLoading: false,
  },
};

export const FaqReducer = persistReducer(
  {
    storage,
    key: "Faq",
    whitelist: [],
  },
  (state = initialState, { type, payload }) => {
    switch (type) {
      case FaqConstant.FAQ_CATEGORIES_REQUEST: {
        return {
          ...state,
          CategoriesList: [],
          Categories: {
            isLoading: true,
          },
        };
      }
      case FaqConstant.FAQ_CATEGORIES_RESPONSE: {
        return {
          ...state,
          CategoriesList: payload,
          Categories: {
            isLoading: false,
          },
        };
      }
      case FaqConstant.FAQ_CATEGORIES_PARENT_REQUEST: {
        return {
          ...state,
          ParentCategoriesList: [],
          ParentCategories: {
            isLoading: true,
          },
        };
      }
      case FaqConstant.FAQ_CATEGORIES_PARENT_RESPONSE: {
        return {
          ...state,
          ParentCategoriesList: payload,
          ParentCategories: {
            isLoading: false,
          },
        };
      }
      case FaqConstant.FAQ_CATEGORIES_STATUS_REQUEST: {
        return {
          ...state,
          CategoriesStatusList: [],
          CategoriesStatus: {
            isLoading: true,
          },
        };
      }
      case FaqConstant.FAQ_CATEGORIES_STATUS_RESPONSE: {
        return {
          ...state,
          CategoriesStatusList: payload,
          CategoriesStatus: {
            isLoading: false,
          },
        };
      }
      case FaqConstant.FAQ_DELETE_REQUEST: {
        return {
          ...state,
          deleteFaq: [],
          faq: {
            isLoading: true,
          },
        };
      }
      case FaqConstant.FAQ_DELETE_RESPONSE: {
        return {
          ...state,
          deleteFaq: payload,
          faq: {
            isLoading: false,
          },
        };
      }
      case FaqConstant.FAQ_REQUEST: {
        return {
          ...state,
          FaqTableList: [],
          FaqisLoading: true,
        };
      }

      case FaqConstant.FAQ_RESPONSE: {
        return {
          console: "FaqConstant.FAQ_RESPONSE",
          ...state,
          FaqTableList: payload,
          FaqisLoading: false,
        };
      }
      case FaqConstant.GET_FAQ_KEYWORD_REQUEST: {
        return {
          ...state,
          FaqKeywordList: [],
          FaqKeyword: {
            isLoading: true,
          },
        };
      }
      case FaqConstant.GET_FAQ_KEYWORD_RESPONSE: {
        return {
          ...state,
          FaqKeywordList: payload,
          FaqKeyword: {
            isLoading: false,
          },
        };
      }
      default:
        return state;
    }
  }
);
